import { Component, Input, Output, EventEmitter, HostListener, ElementRef, NgZone, ViewChild, OnInit, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-custom-slider',
  templateUrl: './custom-slider.component.html',
  styleUrls: ['./custom-slider.component.scss']
})
export class CustomSliderComponent implements OnInit, OnDestroy {
  @Input() sliderValue: number = 50; // Initial position of the ball (percentage)
  @Input() sliderType;
  @Output() sliderValueChanged = new EventEmitter<any>();
  @ViewChild('sliderBall') ballElement: ElementRef | undefined;

  isDragging: boolean = false;
  sliderBar: HTMLElement | null = null;

  constructor(private elementRef: ElementRef, private ngZone: NgZone) {}

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent): any {
    this.sliderBar = document.querySelector('.slider-bar');
    if (!this.sliderBar) {
      return;
    }
    this.isDragging = true;
    this.updateSliderPosition(event);

    window.addEventListener('mousemove', this.onMouseMove.bind(this));
    window.addEventListener('mouseup', this.onMouseUp.bind(this));
  }

  onMouseMove(event: MouseEvent): any {
    if (!this.isDragging || !this.sliderBar) {
      return;
    }

    this.updateSliderPosition(event);
  }

  onMouseUp(): any {
    this.isDragging = false;
    if (this.sliderBar) {
      this.sliderBar = null;
    }
    window.removeEventListener('mousemove', this.onMouseMove.bind(this));
    window.removeEventListener('mouseup', this.onMouseUp.bind(this));
  }

  ngOnInit(): void {
    // Add a global mouseup event listener to handle mouseup events anywhere on the page
    this.ngZone.runOutsideAngular(() => {
      window.addEventListener('mouseup', this.onMouseUp.bind(this));
    });
  }

  ngOnDestroy(): void {
    // Remove the global mouseup event listener when the component is destroyed
    window.removeEventListener('mouseup', this.onMouseUp.bind(this));
  }

  updateSliderPosition(event: MouseEvent): any {
    if (!this.sliderBar) {
      return;
    }

    const rect = this.sliderBar.getBoundingClientRect();

    const mouseX = event.clientX;
    const minX = rect.left + 10; // Adjust for half of the ball's width
    const maxX = rect.right - 10; // Adjust for half of the ball's width

    if (mouseX < minX) {
      this.sliderValue = 0;
    } else if (mouseX > maxX) {
      this.sliderValue = 100;
    } else {
      this.sliderValue = ((mouseX - minX) / (maxX - minX)) * 100;
    }
    const sliderObj = {sliderValue:this.sliderValue, sliderType:this.sliderType};
    this.sliderValueChanged.emit(sliderObj);
  }
}
